import React, { FunctionComponent, SVGProps } from 'react'

export const IconLoader: FunctionComponent<SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      stroke="#0062CA"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14 8.00103C13.9999 9.26809 13.5988 10.5026 12.854 11.5276C12.1092 12.5527 11.059 13.3156 9.85392 13.7071C8.64886 14.0986 7.3508 14.0986 6.14576 13.707C4.94073 13.3155 3.89059 12.5525 3.14584 11.5274C2.4011 10.5023 1.99999 9.26775 2 8.00069C2.00001 6.73363 2.40114 5.4991 3.14589 4.47403C3.89065 3.44895 4.9408 2.68596 6.14584 2.29441C7.35088 1.90286 8.64895 1.90284 9.854 2.29436"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
